import lightIcon from "../assets/dsls-logos/homeassistant_L.png";
import darkIcon from "../assets/dsls-logos/homeassistant_D.png";

/**
 * Retrieves the constants for the Home Assistant domain specific language.
 * @returns {Promise<Object>} The constants object.
 */
export const getHomeAssistantConstants = async () => {
	const constants = {
		enabled: true,
		_id: "homeassistantdsl",
		name: "Home Assistant DSL",
		short: "HomeAssistantDSL",
		description: "A DSL that allows control and integration of Home Assistant to other DSLs in Locsys",
		logoUrl: lightIcon,
		logoUrlDark: darkIcon,
		insertableEntities: {},
		shortDescription: "",
		documentation: "",
		subtypes: [],
		hasValidation: false,
		type: "Textual",
		canTransformTo: ["toolboxer"],
		mustImport: [],
		canImport: [],
		supportsGeneration: false,
		supportsDeployment: false,
		deploymentStoppable: false,
		generationLanguage: "",
		generations: ["Default"],
		generationsOutputMap: {
			Default: "string",
		},
		keywords: [],
		llmSupport: false,
		tags: ["Automation", "Textual"],
		initiallyCollapsed: false,
		isNotEditable: true,
	};
	return constants;
};
